import { toZodSchema } from './DataTypeConfig.zod';
export const validateData = (data, registry) => (config) => {
    if (data === undefined && config.isNullable !== false) {
        return config;
    }
    toZodSchema(config, registry).parse(data);
    return config;
};
//# sourceMappingURL=DataTypeConfig.validate.js.map